import React from 'react';
import './secHeading.css'
const SecHead = (props) => {
    return ( <>
    <div className={props.style3}>
        <h5 className='sub1'>{props.sub1}</h5>
        <h2>{props.title}</h2>
        <h5 >{props.sub2}</h5>
    </div>
    </> );
}
 
export default SecHead;